/**
 * Base de données du téléphone (IndexedDB, via Dexie).
 * Tout ce qui est saisi y est d'abord enregistré : rien n'est perdu sans réseau, ni en fermant l'app.
 */
import Dexie, { type Table } from "dexie";

export type StatutNote = "en_attente" | "envoyee";

export interface Note {
  /** Identifiant créé sur le téléphone : permet de créer sans réseau et d'envoyer deux fois sans doublon. */
  id: string;
  texte: string;
  photo?: Blob;
  creeLe: string;
  statut: StatutNote;
  envoyeeLe?: string;
}

interface Reglage {
  cle: string;
  valeur: string;
}

class BaseLocale extends Dexie {
  notes!: Table<Note, string>;
  reglages!: Table<Reglage, string>;

  constructor() {
    super("noovum-prototype");
    this.version(1).stores({ notes: "id, statut, creeLe", reglages: "cle" });
  }
}

export const base = new BaseLocale();

export async function lireReglage(cle: string): Promise<string | undefined> {
  return (await base.reglages.get(cle))?.valeur;
}

export async function ecrireReglage(cle: string, valeur: string): Promise<void> {
  await base.reglages.put({ cle, valeur });
}
